import { render, staticRenderFns } from "./Son_Radio.vue?vue&type=template&id=9d996e40&scoped=true&"
import script from "./Son_Radio.vue?vue&type=script&lang=js&"
export * from "./Son_Radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d996e40",
  null
  
)

export default component.exports